export const config = {
  isAdmin: false,
  adminPath: /adminv2\/|adminv3\//g
};